import DataGridWithLoading, { ResponsiveDataGridProps, ResponsiveGridColDef } from './DataGridWithLoading';

export default DataGridWithLoading;
export type { ResponsiveDataGridProps, ResponsiveGridColDef };
